module.exports = __webpack_public_path__ + "img/26 Animation 2-squashed.a2272f45.jpg";